import { render } from "./VTour.vue?vue&type=template&id=02809be7"
import script from "./VTour.vue?vue&type=script&lang=js"
export * from "./VTour.vue?vue&type=script&lang=js"

import "./VTour.vue?vue&type=style&index=0&id=02809be7&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tour/VTour.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02809be7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02809be7', __exports__)) {
    api.reload('02809be7', __exports__)
  }
  
  module.hot.accept("./VTour.vue?vue&type=template&id=02809be7", () => {
    api.rerender('02809be7', render)
  })

}


export default __exports__